import { LOCAL_STORAGE_REQUEST_CLOSE_CONFIRMATION_DISABLED_KEY } from '../../../constants/storage'
import { getStorageItem } from '../../../utils/storage'

export function isRequestCloseConfirmationDisabled() {
  return (
    getStorageItem(LOCAL_STORAGE_REQUEST_CLOSE_CONFIRMATION_DISABLED_KEY) ===
    'true'
  )
}
